//================================================================
//  Page: Approvers 
//================================================================

//  Purpose: This page allows administrators to manage the current list of BU approvers for software requests

//================================================================

//Libraries
import React, { useContext } from 'react';

//Contexts
import { GetUser } from '../../../../Library/GlobalContexts';

//Components
import PageComponent from '../../../../Components/PageComponent/PageComponent';
import SideNav from '../../../../Components/SideNav/SideNav';
import TabView from '../../../../Components/TabView/TabView';
import InitialApprovers from './Tabs/InitialApprovers';
import FinalApprovers from './Tabs/FinalApprovers';
import LoAApprovers from './Tabs/LoAApprovers';
import COO from './Tabs/COO';
import BudgetOwners from './Tabs/BudgetOwners';
import FinanceManager from './Tabs/FinanceManager';
import History from './Tabs/History';

//Functions

//Images

//CSS
import '../../Account.css';

export default function Approvers() {

    //------------------------------------------------------
    //  useContext
    //------------------------------------------------------

    const getUser = useContext(GetUser);

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='Account-Container'>
            
            {/* Page Body */}
            <div className='Account-Body'>
                <PageComponent
                    header={
                        <div className='flex flex-col p-4 gap-1 bg-neutral-100 w-full border-solid border-1 border-neutral-300'>
                            <h4 className='flex items-center h-full cursor-default text-[22px]'>
                                Approvers
                            </h4>
                            <p className='text-[#424242] font-sans text-[16px] leading-[24px] m-0'>Below is a list of all the approvers across each approval group. Click <span className='font-bold'>Reassign</span> to modify the approvers in each group.</p>
                        </div>
                    }
                    body={

                        getUser?.roles?.demandManagementAdmin === true ?

                            <TabView
                                defaultView={1}
                                oneTitle={'Initial Approvers'}
                                oneRoute='/admin/approvers?view=initial'
                                oneContent={
                                    <InitialApprovers></InitialApprovers>
                                }
                                twoTitle={'Final Approvers'}
                                twoRoute='/admin/approvers?view=final'
                                twoContent={
                                    <FinalApprovers></FinalApprovers>
                                }
                                threeTitle={'LoA Approvers'}
                                threeRoute='/admin/approvers?view=loa'
                                threeContent={
                                    <LoAApprovers></LoAApprovers>
                                }
                                fourTitle={'COO'}
                                fourRoute='/admin/approvers?view=coo'
                                fourContent={
                                    <COO></COO>
                                }
                                fiveTitle={'History'}
                                fiveRoute='/admin/approvers?view=history'
                                fiveContent={
                                    <History></History>
                                }
                            > </TabView>

                        : getUser?.roles?.commercialAdmin === true ?

                            <TabView
                                defaultView={1}
                                oneTitle={'Budget Owners'}
                                oneRoute='/admin/approvers?view=budgetowners'
                                oneContent={
                                    <BudgetOwners></BudgetOwners>
                                }
                                twoTitle={'Finance Manager'}
                                twoRoute='/admin/approvers?view=financemanager'
                                twoContent={
                                    <FinanceManager></FinanceManager>
                                }
                                sevenTitle={'History'}
                                sevenRoute='/admin/approvers?view=history'
                                sevenContent={
                                    <History></History>
                                }
                            > </TabView>
                        
                        :
                            null

                    }
                ></PageComponent>
            </div>
    
            {/* Side Menu */}
            <div className='Account-SideNav'>
                <SideNav></SideNav>
            </div>

        </div>
    )
}